import React, { useEffect, useState } from 'react';
import './captcha.scss';
import formPhotoMobile from './styles/assets/background_mobile_clear.png';
import formPhoto744 from './styles/assets/background_744_clear.png';
import formPhoto1024 from './styles/assets/background_1024_clear.png';
import { LogoAndTitle } from '../form/sections/LogoAndTitle_Section/LogoAndTitle';
import '../../components/TextField/TextField.scss';
import Button from '../../components/Button/Button';
import { getwayApi } from '../../../config/Constants';
import { SectionHeader } from '../../components/sectionHeader/sectionHeader';
import PBV from '../../assets/pbv.png';
import { CheckLanguage, GetLanguageText } from '../../languages/languagesLoading';


const Captcha = ({ testLogo, formSpec, captchaRespObj, formStyles, submitCaptchaData, setUserCatchaInput, errorState, PBV_icon, dbFormSpec, formId }) => {
    const [screenSize, setScreenSize] = useState(null);

    useEffect(() => {
        setScreenSize(window.innerWidth)
        document.getElementsByTagName('body')[0].style.overflow = 'hidden'
    });

    const languageID = CheckLanguage(dbFormSpec);

    if (languageID != "default") {

        const loadingText = GetLanguageText(languageID);

        return (
            <div className="captcha-page">
                <div className="captcha-content">
                    <SectionHeader sectionTitle={`${loadingText.title}`} styles={{ color: dbFormSpec.color }} />
                    <CaptchaBoxML
                        formSpec={formSpec}
                        captchaRespObj={captchaRespObj}
                        submitCaptchaData={submitCaptchaData}
                        setUserCatchaInput={setUserCatchaInput}
                        errorState={errorState}
                        testLogo={testLogo}
                        trueFormSpec={dbFormSpec}
                        formId={formId}
                        loadingText={loadingText}
                    />
                </div>
            </div>
        );
    }
    else {
        return (
            <div className="captcha-page">
                <div className="captcha-content">
                    <SectionHeader sectionTitle={'Human Verification'} styles={{ color: dbFormSpec.color }} />
                    <CaptchaBox
                        formSpec={formSpec}
                        captchaRespObj={captchaRespObj}
                        submitCaptchaData={submitCaptchaData}
                        setUserCatchaInput={setUserCatchaInput}
                        errorState={errorState}
                        testLogo={testLogo}
                        trueFormSpec={dbFormSpec}
                        formId={formId}
                    />
                </div>
            </div>
        );
    }
};

export default Captcha;

const CaptchaBox = ({ captchaRespObj, submitCaptchaData, setUserCatchaInput, errorState, testLogo, trueFormSpec, formId }) => {
    return (
        <div className="captcha-box">
            {captchaRespObj !== null &&

                <>
                    <p id='captcha-subtext' className='body1' style={{}}>{'Please enter the characters that appear below'}</p>
                    <img id='captcha-image' src={`data:image/png;base64, ${captchaRespObj.image}`}></img>
                    <input
                        id='captcha-input'
                        className='text-field text-input'
                        autoFocus={true}
                        onKeyDown={(e) => { e.keyCode === 13 && submitCaptchaData() }}
                        placeholder={'Enter characters here...'}
                        maxLength='5'                        
                        onChange={e => { setUserCatchaInput(e.target.value); }}
                        onBlur={(e) => { e.target.focus() }}
                    />

                {errorState && <small>Invalid CAPTCHA</small>}
                    <Button label={'Submit'} type='button' onClick={e => submitCaptchaData()} style={{ backgroundColor: trueFormSpec.color }} classes={''} />
                    <img src={PBV} alt="" style={{ width: 107 }} />
                </>
            }
        </div>
    );
};

const CaptchaBoxML = ({ captchaRespObj, submitCaptchaData, setUserCatchaInput, errorState, testLogo, trueFormSpec, formId, loadingText }) => {
    return (
        <div className="captcha-box">
            {captchaRespObj !== null &&

                <>
                <p id='captcha-subtext' className='body1' style={{}}>{`${loadingText.EnterCharacters}`}</p>
                    <img id='captcha-image' src={`data:image/png;base64, ${captchaRespObj.image}`}></img>
                    <input
                        id='captcha-input'
                        className='text-field text-input'
                        autoFocus={true}
                        onKeyDown={(e) => { e.keyCode === 13 && submitCaptchaData() }}
                    placeholder={`${loadingText.enterprompt}`}
                        maxLength='5'
                        onChange={e => { setUserCatchaInput(e.target.value); }}
                        onBlur={(e) => { e.target.focus() }}
                    />

                {errorState && <small>{loadingText.invalid}</small>}
                <Button label={`${loadingText.submit}`} type='button' onClick={e => submitCaptchaData()} style={{ backgroundColor: trueFormSpec.color }} classes={''} />
                    <img src={PBV} alt="" style={{ width: 107 }} />
                </>
            }
        </div>
    );
};